import { thinkificConstants, siteConstants } from "../../constants";
import { thinkificServices } from "../../services";
import { alertActions } from ".";

const listDiscountCodes = () => {
  const request = () => {
    return {
      type: thinkificConstants.LIST_DISCOUNT_CODES_REQUEST,
      payload: null,
    };
  }

  const success = (data) => {
    return {
      type: thinkificConstants.LIST_DISCOUNT_CODES_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: thinkificConstants.LIST_DISCOUNT_CODES_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request());
    thinkificServices.listDiscountCodes()
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

const createDiscountCodes = (file) => {
  const request = (file) => {
    return {
      type: thinkificConstants.CREATE_DISCOUNT_CODES_REQUEST,
      payload: {
        file,
      },
    };
  }

  const success = (data) => {
    return {
      type: thinkificConstants.CREATE_DISCOUNT_CODES_SUCCESS,
      payload: { data },
    };
  }

  const failure = () => {
    return {
      type: thinkificConstants.CREATE_DISCOUNT_CODES_FAILURE,
      payload: null,
    };
  }

  return dispatch => {
    dispatch(request(file));
    thinkificServices.createDiscountCodes(file)
      .then(response => {
        const data = response.data;
        dispatch(success(data));
      })
      .catch(error => {
        if (error.response)
          dispatch(alertActions.error(error.response.data.detail || siteConstants.ERROR_MSG_SERVER_COMMUNICATION));
        else
          dispatch(alertActions.error(siteConstants.ERROR_MSG_SERVER_COMMUNICATION))

        dispatch(failure());
      });
  };
}

export const thinkificActions = {
  listDiscountCodes,
  createDiscountCodes,
};